(function ($) {
    class GM_Tabs {
        constructor() {
            this.$tabList = $('[data-js="tablist"]');
            if (this.$tabList.length) {
                this.initSelectors();
                this.bindEvents();
            }
        }

        initSelectors() {
            this.$tabs = this.$tabList.find('[role="tab"]');
            this.$panelsWrapper = $('[data-js="tabpanels"]');
            this.$panels = this.$panelsWrapper.find('[role="tabpanel"]');
        }

        bindEvents() {
            this.$tabs.on('click', (e) => {
                const $newTab = $(e.currentTarget);
                this.switchTab($newTab);
            });

            this.$tabs.on('keydown', (e) => {
                const $currentTab = $(e.currentTarget);
                let $newTab;

                switch (e.key) {
                    case 'ArrowRight':
                    case 'ArrowDown':
                        e.preventDefault();
                        $newTab = $currentTab.parent().next().find('[role="tab"]');
                        if (!$newTab.length) {
                            $newTab = this.$tabs.first();
                        }
                        break;
                    case 'ArrowLeft':
                    case 'ArrowUp':
                        e.preventDefault();
                        $newTab = $currentTab.parent().prev().find('[role="tab"]');
                        if (!$newTab.length) {
                            $newTab = this.$tabs.last();
                        }
                        break;
                    case 'Home':
                        e.preventDefault();
                        $newTab = this.$tabs.first();
                        break;
                    case 'End':
                        e.preventDefault();
                        $newTab = this.$tabs.last();
                        break;
                    default:
                        return;
                }

                if ($newTab.length) {
                    $newTab.focus();
                    this.switchTab($newTab);
                }
            });
        }

        switchTab($newTab) {
            const isSelected = $newTab.attr('aria-selected') === 'true';
            if (isSelected) return;

            const targetId = $newTab.attr('aria-controls');
            const $newPanel = $(`#${targetId}`);

            this.deactivateTabs();
            this.activateTab($newTab, $newPanel);
        }

        activateTab($tab, $panel) {
            $tab.attr({
                'aria-selected': 'true',
                'tabindex': '0'
            });

            $panel.attr('aria-hidden', 'false').removeAttr('hidden');

            // Sync images if they exist (ensure image visibility when switching tabs on desktop)
            const $images = $panel.find('[data-js-carousel="img"]');
            if ($images.length) {
                $images.attr({
                    'aria-hidden': 'false',
                    'tabindex': '0'
                });
            }
        }

        deactivateTabs() {
            this.$tabs.attr({
                'aria-selected': 'false',
                'tabindex': '-1'
            });

            this.$panels.attr('aria-hidden', 'true').attr('hidden', '');

            // Hide images in deactivated panels
            this.$panels.find('[data-js-carousel="img"]').attr({
                'aria-hidden': 'true',
                'tabindex': '-1'
            });
        }
    }

    $(document).ready(() => new GM_Tabs());
})(jQuery);